module.exports = "./img/desktop_logo.87de8d9.png";